/**
 * Build the public landing cart URL for payment handoff.
 *
 * The customer app no longer pays in-app — it hands the user off to the
 * landing cart page (candleai.org/cart) with everything pre-filled:
 *   - items      the chosen service ids (comma-separated)
 *   - phone      the logged-in user's phone (E.164)
 *   - clinicCode the current clinic's code, when one is set
 *   - verified=1 tells the landing the phone is already OTP-verified here, so
 *                it skips the OTP step (the clinic still asks to confirm)
 *   - lang       so the landing opens in the same language
 *
 * @param {{ landingBase: string, lang: string, items: string[], phone?: string, clinicCode?: string }} args
 * @returns {string} absolute URL
 */
export function buildLandingCartUrl({ landingBase, lang, items, phone, clinicCode }) {
  const path = lang === 'fa' ? '/cart' : '/en/cart';
  const params = new URLSearchParams();
  if (items?.length) params.set('items', items.join(','));
  if (phone) params.set('phone', phone);
  if (clinicCode) params.set('clinicCode', clinicCode);
  params.set('verified', '1');
  params.set('lang', lang || 'fa');
  const base = (landingBase || '').replace(/\/$/, '');
  return `${base}${path}?${params.toString()}`;
}

export default buildLandingCartUrl;
